




























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Used for the possible actions of the footer
import { ButtonOptions, ButtonType } from '../../input/types';

/**
 *  Component that holds the actions for the modal's footer.
 */
@Component
export default class ModalFooterActions extends Vue {

    @Prop({ type: Object })
    private cancel!: ButtonOptions;

    @Prop({ type: Object })
    private confirm!: ButtonOptions;

    /**
     *
     *  Used to get the type for the cancel button.
     *
     *  (i) Defaulting to the transparent type
     *
     */
    private get cancelType(): ButtonType | null {

        if (!this.cancel) {

            return null;

        }

        return this.cancel.type || ButtonType.Transparent;

    }

}

